import React, { useState } from "react";
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage } from '../../../../util/reactIntl';
import { searchTypes } from "../../../../util/searchHelpers";
import {
    FieldDateInput,
    FieldDateRangeInput,
    FieldFilteredSelect,
    FieldLocationAutocompleteInput,
    FieldTextInput,
    Form,
    H3,
    IconClose,
    NamedLink,
} from "../../../../components";

import ContinueIcon from '../../../TopbarContainer/Topbar/images/continue-icon.svg';
import css from './SearchPageHero.module.css';
import { isOriginInUse } from "../../../../util/search";
import { pushToPath, stringify } from "../../../../util/urlHelpers";
import IconHourGlass from "../../../../components/LocationAutocompleteInput/IconHourGlass";
import IconLocationPin from "./IconLocationPin";
import { bookingDatesRequired, composeValidators, required } from "../../../../util/validators";
import BookingDateRangeFilter from "../../BookingDateRangeFilter/BookingDateRangeFilter";
import SectionHero from "../../../../components/StaticPageContainers/SectionHero";
import BackgroundImage from './images/background.png';
import BackgroundImageSitter from './images/background_sitter.png';
import { userTypes } from "../../../../util/userTypes";
import TrustWidgetSmall from "../../../../components/StaticPageContainers/TrustWidgetSmall";

const KEY_CODE_ENTER = 13;

const SearchPageHero = props => {
    const {
        searchType,
        currentSearchParams,
        searchParamsInURL,
        history,
        routeConfiguration,
        config,
        intl,
        onSearchWithFilters,
        initialValuesForDatesSearch,
        liveEdit,
        getHandleChangedValueFn,
        useHistoryPush = true,
    } = props;

    const [inputValue, setInputValue] = useState(null);
    const { key, schemaType } = config;

    const handleKeywordInputChange = event => {
        setInputValue(event.target.value);
    };

    const handleKeywordSearch = () => {
        const trimmedInput = inputValue?.trim();

        if (searchType === searchTypes.houseSitBooking) {
            if (trimmedInput) {
                history.push(`/search-house-sit?keywords=${trimmedInput}`);
            } else {
                history.push(`/search-house-sit`);
            }
        } else if (searchType === searchTypes.houseSitter) {
            if (trimmedInput) {
                history.push(`/search-house-sitter?keywords=${trimmedInput}`);
            } else {
                history.push(`/search-house-sitter`);
            }
        }
    };

    const handleKeywordClear = () => {
        if (searchType === searchTypes.houseSitBooking) {
            history.push(`/search-house-sit`);
        } else if (searchType === searchTypes.houseSitter) {
            history.push(`/search-house-sitter`);
        }
    };

    const handleKeyDownKeyword = event => {
        if (event.keyCode === KEY_CODE_ENTER) {
            event.preventDefault();
            handleKeywordSearch();
        }
    };

    const listingFieldsConfig = config.listing.listingFields;
    const desiredLocations = listingFieldsConfig?.find(c => c.key === 'desiredLocations').enumOptions;

    const petSpecificLink = (
        <NamedLink
            className={css.link}
            name="PetSittingServicesPage"
            params={{ serviceType: 'trusted-services' }}
        >
            <FormattedMessage id="SearchPageHero.infoHouseSitLink" />
        </NamedLink>
    );

    return (
        <div className={css.root}>

            {searchType === searchTypes.houseSitBooking ?
                <>

                    <SectionHero
                        imageUrl={BackgroundImage}
                        header={
                            <H3>
                                Find House Sitting Opportunities and Pet Sitting Jobs
                            </H3>
                        }
                        content={
                            <>
                                <p className={css.info}>
                                    Discover house sitting listings across the UK and around the world. From short local stays to long-term sits abroad, HouseSit Match connects you with verified homeowners who value trusted, caring sitters.
                                </p>

                                <div className="rowMobile fitWidth cenSelf gap20">
                                    <NamedLink
                                        className={css.ctaButton}
                                        name="MembershipPlansPage"
                                        params={{ accountType: userTypes.housesitter }}>
                                        Join to Find House Sitting Opportunities
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>

                                    <NamedLink
                                        className={css.ctaButton}
                                        name="WhatIsHouseSittingPage"
                                    >
                                        Learn How It Works
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>
                                </div>

                                {/* <p className={css.info}>
                                    ⭐ Rated Excellent on Trustpilot (4.8 / 5) • Verified members • UK-based support since 2013
                                </p> */}
                                <TrustWidgetSmall text="• Verified members • UK-based support since 2013" />

                                <p className={css.info}>
                                    Explore verified house sitting listings from
                                    <NamedLink
                                        className={css.link}
                                        name="HouseSittingUK">
                                        across the UK
                                    </NamedLink> and <NamedLink
                                        className={css.link}
                                        name="HouseSittingAbroadDefaultPage">
                                        around the world
                                    </NamedLink>. Every opportunity is posted by a verified homeowner looking for reliable, caring sitters to look after their pets and homes.
                                </p>
                                <p className={css.info}>
                                    Filter by location or pets to find the perfect sit for your next adventure.
                                </p>

                                <FinalForm
                                    initialValues={{}}
                                    onSubmit={() => { }}
                                    render={({ handleSubmit, pristine }) => {
                                        return (
                                            <Form className={css.form} onSubmit={handleSubmit}>
                                                {/* <FieldLocationAutocompleteInput
                                                    className={css.location}
                                                    inputClassName={css.locationInput}
                                                    iconClassName={css.locationIcon}
                                                    rootClassName={css.rootClassName}
                                                    placeholder={intl.formatMessage({ id: "SectionPageHero.inputPlaceholderLocation" })}
                                                    name="location"
                                                    onPickLocation={(pickedOption) => {
                                                        if (pickedOption) {
                                                            const { search, selectedPlace } = pickedOption;
                                                            const { origin, bounds } = selectedPlace;
                                                            const originMaybe = isOriginInUse(config) ? { origin } : {};

                                                            const locationParams = {
                                                                ...originMaybe,
                                                                address: search,
                                                                bounds,
                                                            };
                                                            const searchParams = {
                                                                ...currentSearchParams,
                                                                ...locationParams,
                                                            };
                                                            const searchQuery = stringify(searchParams);
                                                            history.push(`/search-house-sit?${searchQuery}`);
                                                        } else {
                                                            history.push(`/search-house-sit`);
                                                        }
                                                    }}
                                                /> */}
                                                <div className={css.search}>
                                                    <div onClick={handleKeywordSearch}>
                                                        <IconHourGlass
                                                            className={css.searchKeywordIcon}
                                                        />
                                                    </div>
                                                    <input
                                                        className={css.input}
                                                        type='text'
                                                        value={inputValue}
                                                        placeholder={intl.formatMessage({ id: "SectionPageHero.inputLocationPlaceholderName" })}
                                                        onChange={handleKeywordInputChange}
                                                        onKeyDown={handleKeyDownKeyword}
                                                    />
                                                    <div onClick={() => {
                                                        setInputValue('');
                                                        handleKeywordClear();
                                                    }}>
                                                        <IconClose className={css.closeIcon} />
                                                    </div>
                                                </div>

                                                <BookingDateRangeFilter
                                                    id={"id"}
                                                    label={intl.formatMessage({ id: 'FilterComponent.datesLabel' })}
                                                    queryParamNames={['dates']}
                                                    initialValues={initialValuesForDatesSearch(["dates"], liveEdit)}
                                                    onSubmit={getHandleChangedValueFn(useHistoryPush)}
                                                    minimumNights={1}
                                                />
                                            </Form>
                                        );
                                    }}
                                />
                            </>}
                    />

                </>
                :
                <>

                    <SectionHero
                        imageUrl={BackgroundImageSitter}
                        header={
                            <H3>
                                Find Trusted House Sitters and Pet Sitters Near You
                            </H3>
                        }
                        content={
                            <>
                                <p className={css.info}>
                                    Whether you’re planning a weekend away or a long trip abroad, HouseSit Match helps you find reliable, verified house sitters and pet sitters who care for your home and pets as if they were their own. Enjoy complete peace of mind knowing every sitter in our community has been ID-checked and reviewed by real homeowners.
                                </p>

                                <div className="rowMobile fitWidth cenSelf gap20">
                                    <NamedLink
                                        className={css.ctaButton}
                                        name="MembershipPlansPage"
                                        params={{ accountType: userTypes.homeowner }}>
                                        Join to Find a House Sitter
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>

                                    <NamedLink
                                        className={css.ctaButton}
                                        name="WhatIsHouseSittingPage"
                                    >
                                        Learn How It Works
                                        <img src={ContinueIcon} className={css.icon} />
                                    </NamedLink>
                                </div>

                                {/* <p className={css.info}>
                                    ⭐ Rated Excellent on Trustpilot (4.8 / 5) • Verified members • UK-based support since 2013
                                </p> */}
                                <TrustWidgetSmall text="• Verified members • UK-based support since 2013" />

                                <p className={css.info}>
                                    Find experienced, trusted sitters who are ready to care for your home and pets.
                                    Every member on HouseSit Match
                                    <NamedLink
                                        className={css.link}
                                        name="TrustAndSafetyPage">
                                        completes an ID check
                                    </NamedLink> and receives verified reviews from real homeowners, so you can choose with confidence.

                                </p>
                                <p className={css.info}>
                                    Filter by name or location or pets to find your ideal match..
                                </p>

                                <div className={css.filters}>
                                    <div className={css.search}>
                                        <div onClick={handleKeywordSearch}>
                                            <IconHourGlass
                                                className={css.searchKeywordIcon}
                                            />
                                        </div>
                                        <input
                                            className={css.input}
                                            type='text'
                                            placeholder={intl.formatMessage({ id: "SectionPageHero.inputPlaceholderName" })}
                                            onChange={handleKeywordInputChange}
                                            onKeyDown={handleKeyDownKeyword}
                                        />
                                    </div>
                                    <FinalForm
                                        onSubmit={() => { }}
                                        render={formRenderProps => {
                                            const handleLocationSearch = () => {
                                                onSearchWithFilters(formRenderProps.values.desiredLocations, config);
                                            };

                                            return (
                                                <Form onSubmit={formRenderProps.handleSubmit}>
                                                    <div className={css.search}>
                                                        <FieldFilteredSelect
                                                            id="desiredLocations"
                                                            name="desiredLocations"
                                                            options={desiredLocations}
                                                            onChangeCustom={(value) => {
                                                                onSearchWithFilters(value, config);
                                                            }}
                                                            placeholder={intl.formatMessage({ id: 'SectionPageHero.searchDesiredLocationPlaceholder' })}
                                                            noItemFoundPlaceholder={intl.formatMessage({ id: 'SectionPageHero.noItemFound' })}
                                                        />

                                                        <div onClick={handleLocationSearch}>
                                                            <IconLocationPin
                                                                className={css.searchLocationIcon}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form>
                                            );
                                        }}
                                    />
                                </div>

                            </>}
                    />



                </>
            }
        </div>
    );
};

export default SearchPageHero;